<template>
  <!-- เนื้อคู่มือของภารกิจหนึ่ง: ความสำคัญ → ขั้นตอน → เงื่อนไขเสร็จ → ข้อควรระวัง -->
  <div>
    <div class="ctg-purpose mb-3">{{ guide.purpose }}</div>
    <v-timeline dense align-top class="ctg-timeline pt-0">
      <v-timeline-item
        v-for="(s, i) in guide.steps"
        :key="i"
        small
        fill-dot
        :color="actorOf(s).color"
        :icon="actorOf(s).icon"
      >
        <div class="d-flex flex-wrap align-center">
          <span class="ctg-step-no mr-1">ขั้นที่ {{ i + 1 }}</span>
          <span class="ctg-step-title mr-2">{{ s.title }}</span>
          <v-chip x-small :color="actorOf(s).color" dark class="mr-2">{{ actorOf(s).label }}</v-chip>
          <v-btn v-if="s.to" x-small text color="primary" class="px-1" @click="$emit('navigate', s.to)">
            เปิดหน้านี้ <v-icon x-small right>mdi-open-in-app</v-icon>
          </v-btn>
        </div>
        <div v-if="s.detail" class="ctg-step-detail">{{ s.detail }}</div>
        <div v-if="s.tip" class="ctg-step-tip">
          <v-icon x-small color="amber darken-3">mdi-lightbulb-on-outline</v-icon> {{ s.tip }}
        </div>
      </v-timeline-item>
    </v-timeline>

    <div class="ctg-box ctg-box--done mt-2">
      <v-icon small color="success" class="mr-1">mdi-flag-checkered</v-icon>
      <b>ระบบถือว่า “ทำรายการแล้ว” เมื่อ:</b> {{ guide.doneWhen }}
    </div>
    <div v-if="guide.cautions && guide.cautions.length" class="ctg-box ctg-box--warn mt-2">
      <div class="font-weight-bold mb-1">
        <v-icon small color="deep-orange">mdi-alert-outline</v-icon> ข้อควรระวัง
      </div>
      <div v-for="(c, i) in guide.cautions" :key="i" class="ctg-li">• {{ c }}</div>
    </div>
  </div>
</template>

<script>
import { ACTORS } from "./collegeTaskCatalog";

export default {
  name: "CollegeTaskGuideBody",

  props: {
    guide: { type: Object, required: true }
  },

  methods: {
    actorOf(step) {
      return ACTORS[step.actor] || ACTORS.staff;
    }
  }
};
</script>

<style scoped>
.ctg-purpose {
  color: #37474f;
  line-height: 1.6;
}
.ctg-timeline {
  margin-left: -8px;
}
.ctg-step-no {
  font-size: 0.75rem;
  color: #78909c;
}
.ctg-step-title {
  font-weight: 600;
  color: #263238;
}
.ctg-step-detail {
  color: #546e7a;
  font-size: 0.88rem;
  margin-top: 2px;
}
.ctg-step-tip {
  color: #8d6e00;
  font-size: 0.82rem;
  margin-top: 2px;
}
.ctg-box {
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.88rem;
}
.ctg-box--done {
  background: #f1f8e9;
  border: 1px solid #c5e1a5;
}
.ctg-box--warn {
  background: #fff8e1;
  border: 1px solid #ffe082;
}
.ctg-li {
  color: #5d4037;
}
</style>
